module.exports = __webpack_public_path__ + "static/media/illo-bulb.2d2eee8e.png";